import { TableCell } from '@mui/material'
import { formatToDate, formatToDateTime } from 'brazilian-values'

import { FloraTypography, Tooltip } from '@grupoboticario/flora-react'

import LargeText from '@/components/Table/Generic/LargeText/LargeText'
import NumberTextWithColor from '@/components/Table/Generic/NumberTextWithColor/NumberTextWithColor'
import TierTag from '@/components/Table/Generic/TierTag/TierTag'
import { formatCurrency } from '@/utils/format/formatCurrency'
import { parseDatetime } from '@/utils/format/parseDatetime'
import { parseLocalDate } from '@/utils/format/parseLocalDate'
import { translateMovementTypes } from '@/utils/format/translateMovementTypes'

import { ExtractFieldsProps } from './ExtractFields.types'

/**
 * Traduz o tipo de movimentação adicionando um separador.
 *
 * @param text - Texto do tipo de movimentação
 * @returns Texto formatado com separador
 */
const translateMovementType = (text: string): string => (text ? ` | ${text}` : '')

/**
 * Retorna mensagem adicional baseada no tipo de movimentação.
 *
 * @param movementType - Tipo de movimentação usado para validar se a mensagem adicional deve ser exibida
 * @param event - Evento a ser formatado na mensagem adicional
 * @returns Mensagem formatada ou string vazia
 */
const getMessage = (movementType: string, event: string): string => {
  const movementTypes = ['MANUAL_ADJUSTMENT', 'MISSION_ACCOMPLISHED', 'PURCHASE_CANCELLED', 'ACCELERATOR']

  if (movementTypes.includes(movementType)) {
    return translateMovementType(event)
  }

  return ''
}

const ExtractFields = ({ row, isFutureEvent, setEvent }: ExtractFieldsProps) => {
  return (
    <>
      <TableCell>
        <FloraTypography fontSize="bodySmallStandard">{formatToDateTime(new Date(row?.eventDate))}</FloraTypography>
      </TableCell>
      <TableCell>
        <FloraTypography fontSize="bodySmallStandard">{formatToDateTime(new Date(row?.createdAt))}</FloraTypography>
      </TableCell>
      <TableCell>
        <LargeText
          lengthToBreak={24}
          onOpenClick={setEvent}
          text={`${translateMovementTypes[row?.movementType as keyof typeof translateMovementTypes] || 'Movimentação desconhecida'}${getMessage(row?.movementType, row?.event)} ${
            isFutureEvent ? `válido a partir de ${parseLocalDate(row?.availableFrom)}` : ''
          }`}
        />
      </TableCell>
      <TableCell>
        <FloraTypography fontSize="bodySmallStandard">
          {formatCurrency(row?.payment?.total || row?.amountValue || 0)}
        </FloraTypography>
      </TableCell>
      <TableCell>
        <NumberTextWithColor value={row?.amountPoint}>{row?.amountPoint}</NumberTextWithColor>
      </TableCell>
      <TableCell>
        <Tooltip text={formatToDateTime(new Date(parseDatetime(row?.expirationDate?.split('T')[0])))}>
          <FloraTypography fontSize="bodySmallStandard">
            {row?.expirationDate ? formatToDate(new Date(parseDatetime(row?.expirationDate?.split('T')[0]))) : '-'}
          </FloraTypography>
        </Tooltip>
      </TableCell>
      <TableCell>
        <FloraTypography fontSize="bodySmallStandard">{row?.origin?.channel || '-'}</FloraTypography>
      </TableCell>
      <TableCell>
        <FloraTypography fontSize="bodySmallStandard">{row?.movementId || '-'}</FloraTypography>
      </TableCell>
      <TableCell>
        <TierTag tier={row?.tier} />
      </TableCell>
    </>
  )
}

ExtractFields.defaultProps = {
  row: {}
}

export default ExtractFields
